import TableCompany from './TableCompany';
import TableString from './TableString';

export const SORTING = {
  ID: 'ID',
  COMPANY_NAME: 'COMPANY_NAME',
  RATE_ADD: 'RATE_ADD',
  RATE_REMOVE: 'RATE_REMOVE',
  DATE_REQUESTED: 'DATE_REQUESTED',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const SEARCH_OPTIONS = {
  keys: [
    { name: 'id', weight: 1 },
    { name: 'companyName', weight: 1 },
    { name: 'requester', weight: 1 },
    { name: 'rateToAdd', weight: 1 },
    { name: 'rateToRemove', weight: 1 },
    { name: 'dateRequested', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};

export const TABLE_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    items: [
      {
        action: {
          type: 'id-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort ID',
      },
    ],
    renderComponent: {
      component: TableString,
      value: 'value',
      props: {
        className: 'text-14-22',
      },
    },
    width: 200,
    minWidth: 200,
    maxWidth: 280,
  },
  {
    Header: 'Company Name',
    accessor: 'companyName',
    subAccessors: ['requester'],
    items: [
      {
        action: {
          type: 'company-name-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort by Company Name',
      },
      {
        action: {
          type: 'requester-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort by Requester',
      },
    ],
    renderComponent: {
      component: TableCompany,
      value: 'companyName',
      optionalProps: ['requester'],
    },
    width: 220,
    minWidth: 200,
    maxWidth: 280,
  },
  {
    Header: 'Add?',
    accessor: 'rateToAdd',
    items: [
      {
        action: {
          type: 'add-yes-first',
        },
        icon: 'alphabet',
        name: "Sort 'yes' first",
      },
      {
        action: {
          type: 'add-no-first',
        },
        icon: 'alphabet',
        name: "Sort 'No' first",
      },
    ],
    renderComponent: {
      component: TableString,
      value: 'value',
    },
    width: 80,
    minWidth: 40,
    maxWidth: 100,
  },
  {
    Header: 'Remove?',
    accessor: 'rateToRemove',
    items: [
      {
        action: {
          type: 'remove-yes-first',
        },
        icon: 'alphabet',
        name: "Sort 'yes' first",
      },
      {
        action: {
          type: 'remove-no-first',
        },
        icon: 'alphabet',
        name: "Sort 'No' first",
      },
    ],
    renderComponent: {
      component: TableString,
      value: 'value',
    },
    width: 80,
    minWidth: 40,
    maxWidth: 100,
  },
  {
    Header: 'Date Requested',
    accessor: 'dateRequested',
    items: [
      {
        action: {
          type: 'requested-newest',
        },
        icon: 'sort-ascending',
        name: 'Sort Newest First',
      },
      {
        action: {
          type: 'requested-oldest',
        },
        icon: 'sort-descending',
        name: 'Sort Oldest First',
      },
    ],
    renderComponent: {
      component: TableString,
      value: 'value',
    },
    width: 120,
    minWidth: 100,
    maxWidth: 200,
  },
];
